import type { AntSimWorld } from '../sim/contracts';

export class PopulationHUD {
  readonly dom: HTMLElement;
  private redSpan: HTMLSpanElement;
  private blackSpan: HTMLSpanElement;

  constructor(private world: AntSimWorld) {
    const root = document.createElement('div');
    root.style.cssText = [
      'position:fixed',
      'top:8px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:rgba(15,20,25,0.78)',
      'color:#eee',
      'border-radius:8px',
      'padding:6px 12px',
      'font:12px/1.3 system-ui, sans-serif',
      'pointer-events:none',
      'z-index:5',
      'box-shadow:0 2px 8px rgba(0,0,0,0.4)',
      'display:flex',
      'gap:12px',
      'align-items:center',
    ].join(';');

    const red = document.createElement('span');
    red.className = 'red';
    red.style.color = '#c94a2e';
    red.textContent = '\u25CF 0';

    const divider = document.createElement('span');
    divider.style.cssText = 'width:1px;height:14px;background:rgba(255,255,255,0.25)';

    const black = document.createElement('span');
    black.className = 'black';
    // Bright slate — the ant is black, but the HUD sits on dark chrome and
    // needs a readable token, not literal #2a2a2a-on-#0f1419.
    black.style.color = '#bac3cc';
    black.textContent = '\u25CF 0';

    root.appendChild(red);
    root.appendChild(divider);
    root.appendChild(black);
    document.body.appendChild(root);

    this.dom = root;
    this.redSpan = red;
    this.blackSpan = black;
  }

  update(): void {
    let red = 0;
    let black = 0;
    for (const a of this.world.ants) {
      if (!a.alive) continue;
      if (a.team === 0) red++;
      else black++;
    }
    this.redSpan.textContent = `\u25CF ${red}`;
    this.blackSpan.textContent = `\u25CF ${black}`;
  }
}
